import { Button, ButtonProps } from "@chakra-ui/react";

const CustomButtom = ({ children, ...rest }: ButtonProps) => {
  return (
    <Button
      width="100%"
      height="56px"
      marginTop="1rem"
      background="brand.primary"
      borderRadius="8px"
      color="brand.textLight"
      fontSize="20px"
      fontFamily="semi-bold"
      display="flex"
      justifyContent="center"
      alignItems="center"
      gap="1rem"
      mb="0"
      {...rest}
    >
      {children}
    </Button>
  );
};

export default CustomButtom;
